import { render, staticRenderFns } from "./AuditScoreResultsTable.vue?vue&type=template&id=0150f530&"
import script from "./AuditScoreResultsTable.vue?vue&type=script&lang=ts&"
export * from "./AuditScoreResultsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports